// src/queries/getPresignedUrlsQuery.js
import { gql } from "@apollo/client";

export const GET_PRESIGNED_URLS_QUERY = gql`
  query GetPresignedUrls($input: PresignedUrlInput!) {
    getPresignedUrls(input: $input) {
      presignedUrls
    }
  }
`;
